import React, { useState } from 'react'
import ReactModal from 'react-modal'
import { useTranslation } from 'react-i18next'
import '../../styles/modals/TransferDumoPointsModal.css'
import { ReactComponent as CloseModalIcon } from '../../svg/normalSvgs/CloseModalIcon.svg'
import TransferDumoPointsBackground from '../../svg/normalSvgs/TransferDumoPointsBackground.svg'
import { useUser } from '../../context/user'

function TransferDumoPointsModal({ modalIsOpen, closeModal }) {
    const { availablePoints } = useUser()
    const { t } = useTranslation()
    const [account, setAccount] = useState('')
    const [points, setPoints] = useState()

    React.useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root')
            document.getElementById('feedid').style.filter = 'blur(5px)'
        } else {
            document.getElementById('feedid').style.filter = 'unset'
        }
    }, [modalIsOpen])

    return (
        <ReactModal
            transparent
            isOpen={modalIsOpen}
            ariaHideApp={false}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            onRequestClose={closeModal}
            style={{
                overlay: {
                    zIndex: 3,
                    overflowY: 'scroll',
                    height: '100vh',
                },
                content: {
                    inset: 0,
                    padding: 0,
                    backgroundColor: 'transparent',
                    maxHeight: '95vh',
                    border: 'none',
                    borderRadius: 10,
                    boxShadow: 'none',
                    overflow: 'hidden',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: 20,
                    marginBottom: 20,
                },
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="how-are-you-modal-icon" onClick={() => closeModal()}>
                    <CloseModalIcon />
                </div>
            </div>
            <div className="transfer-dumo-modal-container " style={{ backgroundImage: `url(${TransferDumoPointsBackground})` }}>
                <div className="transfer-dumo-title-container">
                    <div className="transfer-dumo-title">{t('Send earned points to DUMO')}</div>
                </div>
                <div className="transfer-dumo-form">
                    <div className="transfer-dumo-form-label">{t('Type your DUMO account here')}</div>
                    <div className="transfer-dumo-form-input">
                        <input type="text" placeholder={t('Enter your DUMO account')} value={account} onChange={(e) => setAccount(e.target.value)} autoComplete="off" />
                    </div>
                    <div className="transfer-dumo-form-points">
                        <div className="transfer-dumo-form-points-text">{t('Amount of points you want to transfer')}</div>
                        <div className="transfer-dumo-form-points-input">
                            <input type="number" placeholder={t('0')} value={points} onChange={(e) => setPoints(e.target.value)} autoComplete="off" />
                        </div>
                    </div>
                    <div className="transfer-dumo-form-points-available">
                        {t('Available points')}: {availablePoints}
                    </div>
                </div>
                <div className="transfer-dumo-modal-button-container">
                    <button className="transfer-dumo-modal-button-select" onClick={() => closeModal()}>
                        {t('close')}
                    </button>
                    <button className="transfer-dumo-modal-button-close">{t('Proceed')}</button>
                </div>
            </div>
        </ReactModal>
    )
}

export default TransferDumoPointsModal
